export const legacyAddTag = (tag) => {
    window.zE('webWidget', 'chat:addTags', tag);
};

export const messagingAddTag = (tag) => {
    window.zE('messenger:set', 'conversationTags', tag);
};
